/**
 * Adjectives that make a noun funny.
 *
 * Chosen to be daft rather than rude: this string goes on three other people's screens, and every
 * combination the registry can produce has to be one nobody has to explain.
 */

import type { NameWordList } from '@/identity/playerNameContract';

export const SILLY_ADJECTIVES: NameWordList = [
  'Soggy',
  'Feral',
  'Smug',
  'Damp',
  'Reckless',
  'Anxious',
  'Wobbly',
  'Greasy',
  'Furious',
  'Sleepy',
  'Bashful',
  'Unhinged',
  'Crispy',
  'Doomed',
  'Lumpy',
  'Sneaky',
  'Gloomy',
  'Chunky',
  'Frantic',
  'Dizzy',
  'Suspicious',
  'Clammy',
  'Bewildered',
  'Rowdy',
  'Stubborn',
  'Ominous',
  'Squeaky',
  'Haunted',
  'Nervous',
  'Rusty',
];
